import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-sales-pojection',
  templateUrl: './sales-pojection.component.html',
  styleUrls: ['./sales-pojection.component.css']
})
export class SalesPojectionComponent implements OnInit {
  loaderShown=true;
  CardShown=false;
  count=0;
  output:any=[];
  each:any=[];
  next_output:any=[];
  New_count=0;
  search_flag=false;
  filter_flag=false;
  search:string='';
  isShownEmployee=false;
  searchEmployee:string='';
  employee_id:any
  admin_id=localStorage.getItem('admin_id');
  employee:any=[];

  data={
    target:"",
    manager:"",
    Due_balance:"",
    receiprs:"",
    status:""
  }
  search_data={
    employee_name:""

  }
  body ={
    month_filter: ""
        }
  AvgSale="";
  AcReceipt="";
  InReceipt="";
  AgSales="";
  AgAReceipt="";
  AgIReceipt="";

  userTypedropdown:any=[];
  departmentDropdown:any=[];
  selectedUserType:string='';
  selectedDepartment:string='';
  excelMonth:string='';
  isDownloading:boolean=false;
  
  constructor(private salesService:ServiceService,private route: ActivatedRoute, private router: Router) { }

    //-------------function for search--------------------
Search(){
  console.log(this.body.month_filter);
  
  this.search_data.employee_name="";
  this.filter_flag=false;


  this.count=0
  this.New_count=0;
  console.log("customer search",this.search);
  
  this.loaderShown=true;
  this.CardShown=false;
  this.output=[];
  
  if(this.search!='')
  {
  this.search_flag=true;
  this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
  this.output=res.data
  // debugger
 // console.log("output1=",this.output)
  this.loaderShown=false;
  this.CardShown=true;
  })
 }
 else{
  this.search_flag=false;
   //-------api get()calling-------------
   this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
    this.output=res.data

    this.loaderShown=false;
    this.CardShown=true;
    })

 }
}
clicks_previous(){
  if(this.New_count==0){
    return;
  }
  else{
    this.New_count=this.New_count-1;
    this.count=this.New_count; 
  }
  if(this.search_flag==false && this.filter_flag==false){
  this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
    this.output=res.data
  })
  }

  else if(this.filter_flag==true){

    this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.employee_id,this.body).subscribe((res)=>{
      this.output=res.data
     
    })

  }
  else if(this.search_flag==true){
    this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
      this.output=res.data;
    })

  }
}
//-------function for click next-------
clicks_next(){
  this.count=this.count+1
  if(this.search_flag==true){
    this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
      this.next_output=res.data
      if(this.next_output.length!=0){
        this.output=this.next_output;
        this.New_count=this.count;
      }
    })
  }
  /*-----------------new filter-------------------------------*/
else if(this.filter_flag==true){
  this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.employee_id,this.body).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })

}
  /*---------------------------end filter--------------------*/
  else{
  this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })
}
}
//-------date formating-------------
  
ViewDetail(Id:any){
  //-------api get()calling-------------
   this.salesService.GetSaleProjectionbrandwiseINV(Id).subscribe((res)=>{
     this.each=res.data;
     this.data.target=this.each[0].agreed_sales;
     this.data.receiprs=this.each[0].agreed_receipts;
     this.data.Due_balance=this.each[0].due_balance;
     this.data.manager=this.each[0].company_brand_manager_name;
     this.data.status=this.each[0].status;
    //  debugger
  
    console.log("details =",this.output)
  })
}
  //-------------function for search--------------------
  SearchEmployee(){

    this.search="";
    this.search_flag=false

    this.loaderShown=true;
    this.CardShown=false;
    this.count=0;
    this.New_count=0;
    if(this.search_data.employee_name!='')
    {
    this.isShownEmployee=true;
    this.filter_flag=true;
   
    this.searchEmployee=this.search_data.employee_name
    this.salesService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
    this.employee=res.data;
    this.loaderShown=false;
    this.CardShown=true;
    })
  }
  else{
    this.filter_flag=false;
    this.isShownEmployee=false;
  //-------api get()calling-------------
   this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
    this.output=res.data

    this.loaderShown=false;
    this.CardShown=true;
    })

  }
  }
  //---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){

  this.isShownEmployee=false
  //this.searchEmployee=value2
  this.employee_id=value1
  this.search_data.employee_name=value2;
  this.loaderShown=true;
  this.CardShown=false;
  this.salesService.GetSaleProjectionbrandwise(this.count,this.search,value1,this.body).subscribe((res)=>{
    this.output=res.data
    this.loaderShown=false;
    this.CardShown=true;
    console.log("Id =",value1);
    console.log("output =",this.output)

    this.AvgSale=res.avearage_sales_total
    this.AcReceipt=res.active_due_amt_total
    this.InReceipt=res.inactive_due_amt_total
    this.AgSales=res.agreed_sales_total
    this.AgAReceipt=res.agreed_active_receipts_total
    this.AgIReceipt=res.agreed_inactive_receipts_total
    })

}
 getUsertype(): void {
    this.salesService.usertypeDropdown().subscribe((res:any)=>{
      this.userTypedropdown=res.data;
    })
  }

  getDepartment(): void {
    this.salesService.departmentDropdown().subscribe((res:any)=>{
      this.departmentDropdown=res.data;
    })
  }

  openExcelDialog(): void {
    this.excelMonth=this.body.month_filter;
    this.selectedUserType='';
    this.selectedDepartment='';
    this.getUsertype();
    this.getDepartment();
  }

  downloadExcel(): void {
    if(!this.excelMonth){
      return;
    }
    this.isDownloading=true;
    this.salesService.downloadSalesProjectionExcel(this.excelMonth,this.selectedUserType,this.selectedDepartment).subscribe({
      next:(response:any)=>{
        if(response.status===204 || !response.body || response.body.size===0){
          this.isDownloading=false;
          return;
        }
        const blob=response.body;
        const url=window.URL.createObjectURL(blob);
        const link=document.createElement('a');
        link.href=url;
        link.download=`Sales_Projection_${this.excelMonth}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.isDownloading=false;
      },
      error:(err)=>{
        console.error('Download error:',err);
        this.isDownloading=false;
      }
    })
  }

  ngOnInit(): void {
    const today = new Date();
    const year = today.getFullYear(); // Get the current year
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1 and ensure two digits
    this.body.month_filter =    `${year}-${month}`

        //-------api get()calling-------------
        this.salesService.GetSaleProjectionbrandwise(this.count,this.search,this.admin_id,this.body).subscribe((res)=>{
          this.output=res.data
          this.loaderShown=false;
          this.CardShown=true;
          console.log("details =",this.output)
          })
      }
      openDatePicker(event: MouseEvent): void {
  const input = event.target as any;
  if (input?.showPicker) {
    input.showPicker();
  }
}
  }


